<template>
  <div class="row align-items-center">
    <validationProvider
      id="supInput"
      tag="div"
      class="col-md-12 px-0"
      v-slot="{ errors, ariaMsg, classes }"
      rules="required"
      name="Nome do Suporte"
      disabled
    >
      <label class="label_default my-3" :class="classes">Nome do suporte</label>
      <input
        type="text"
        class="input_default form-control"
        :class="classes"
        :value="name"
      />
    </validationProvider>

    <validationProvider
      id="supInput"
      tag="div"
      class="col-md-6 pl-0 mt-3"
      v-slot="{ errors, ariaMsg, classes }"
      rules="required"
      name="Fornecedor"
    >
      <label class="label_default my-3" :class="classes">Fornecedor</label>
      <input
        type="text"
        class="input_default form-control"
        :class="classes"
        :value="supplier"
        disabled
      />
    </validationProvider>

     <validationProvider
      id="supInput"
      tag="div"
      class="col-md-6 pr-0 mt-3"
      v-slot="{ errors, ariaMsg, classes }"
      rules="required"
      name="Nome do atendente"
    >
      <label class="label_default my-3" :class="classes">Nome do atendente</label>
      <input
        type="text"
        class="input_default form-control"
        :class="classes"
        :value="clerk"
        disabled
      />
    </validationProvider>

    <validationProvider
      id="supInput"
      tag="div"
      class="col-md-6 pl-0"
      v-slot="{ errors, ariaMsg, classes }"
      rules="required"
      name="Telefone"
    >
      <label class="label_default my-3" :class="classes">Telefone</label>
      <input
        type="number"
        class="input_default form-control"
        :class="classes"
        :value="phone"
        disabled
      />
    </validationProvider>

    <validationProvider
      id="supInput"
      tag="div"
      class="col-md-6 pr-0"
      v-slot="{ errors, ariaMsg, classes }"
      rules="required"
      name="Telefone secundário"
    >
      <label class="label_default my-3" :class="classes">Telefone secundário</label>
      <input
        type="number"
        class="input_default form-control"
        :class="classes"
        :value="secondaryPhone"
        disabled
      />
    </validationProvider>

    <validationProvider
      id="supInput"
      tag="div"
      class="col-md-12 px-0"
      v-slot="{ errors, ariaMsg, classes }"
      rules="required"
      name="email"
    >
      <label class="label_default my-3" :class="classes">email</label>
      <input
        type="text"
        class="input_default form-control"
        :class="classes"
        :value="email"
        disabled
      />
    </validationProvider>

    
    
  </div>
</template>

<script>
export default {
  props: ["name","supplier","clerk","phone","secondaryPhone","email"]
};
</script>

<style scoped>
hr {
  border-top: 2px solid #f4f4f4 !important;
}
.input_default {
  height: 35px;
}
.titulo_dash {
  color: #2474b2;
  font-weight: 700;
}
.label_default {
  font-size: 14px;
  color: #2474b2 !important;
  font-weight: 500;
}
label.failed {
  color: #dc3545 !important;
}
@media screen and (max-width:767px){
  #supInput{
    padding-left: 0;
    padding-right: 15px!important;
  }
}
</style>